import { lazy } from "react";

import Landing from "../components/layout/Landing";
const PrivateRoute = lazy(() => import("../components/routing/PrivateRoute"));

const ActivateAccount = lazy(() => import("../components/activate-account"));
const ChangePassword = lazy(() => import("../components/auth/ChangePassword"));
const Login = lazy(() => import("../components/auth/Login"));
const Register = lazy(() => import("../components/auth/Register"));
const ResetPassword = lazy(() => import("../components/auth/ResetPassword"));
const RetrievePassword = lazy(() =>
  import("../components/auth/RetrievePassword")
);
const BrowseTrips = lazy(() => import("../components/browse-trips"));
const TripDetails = lazy(() =>
  import("../components/browse-trips/TripDetails")
);
const Dashboard = lazy(() => import("../components/dashboard/Dashboard"));

const About = lazy(() => import("../components/layout/About"));
const TermsAndConditions = lazy(() => import("../components/layout/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("../components/layout/PrivacyPolicy"));
const ContactUs = lazy(() => import("../components/layout/ContactUs"));
// const Blog = lazy(() => import("../components/layout/Blog"));
// const Contests = lazy(() => import("../components/layout/Contests"));
const HowItWorks = lazy(() => import("../components/layout/HowItWorks"));
const MembershipPlans = lazy(() =>
  import("../components/layout/MembershipPlans")
);
const NotFound = lazy(() => import("../components/layout/NotFound"));
// const Shop = lazy(() => import("../components/layout/Shop"));

const Profile = lazy(() => import("../components/profile/Profile"));
const Profiles = lazy(() => import("../components/profiles/Profiles"));
const AgentWizard = lazy(() =>
  import("../components/profile-wizard/AgentWizard")
);
const Trip = lazy(() => import("../components/trip/Trip"));
const TripForm = lazy(() => import("../components/trips/TripForm"));
const Trips = lazy(() => import("../components/trips/Trips"));
// const MyProfile = lazy(() => import("../components/profiles/MyProfile"));

export const routes = [
  { path: "/", element: <Landing /> },
  {
    path: "how-it-works",
    element: <HowItWorks />,
  },
  { path: "about-us", element: <About /> },
  // { path: "blog", element: <Blog /> },
  // {
  //   path: "Contests",
  //   element: <Contests />,
  // },
  // { path: "shop", element: <Shop /> },
  {
    path: "register",
    element: <Register />,
  },
  { path: "login", element: <Login /> },
  {
    path: "activate-account/:id",
    element: <ActivateAccount />,
  },
  {
    path: "retrieve-password",
    element: <RetrievePassword />,
  },
  {
    path: "reset-password",
    element: <ResetPassword />,
  },
  {
    path: "browse-agents",
    element: <Profiles />,
  },
  { path: "trips", element: <Trips /> },
  {
    path: "browse-trips",
    element: <BrowseTrips />,
  },
  {
    path: "browse-trips/:id",
    element: <TripDetails />,
  },

  // private routes
  {
    path: "profile/:id",
    element: <PrivateRoute component={Profile} />,
  },
  {
    path: "dashboard",
    element: <PrivateRoute component={Dashboard} />,
  },
  {
    path: "create-agent-profile",
    element: <PrivateRoute component={AgentWizard} />,
  },
  {
    path: "change-password",
    element: <PrivateRoute component={ChangePassword} />,
  },
  {
    path: "create-new-trip",
    element: <PrivateRoute component={TripForm} />,
  },
  {
    path: "trips/:id",
    element: <PrivateRoute component={Trip} />,
  },
  {
    path: "membership-plans",
    element: <PrivateRoute component={MembershipPlans} />,
  },
  {
    path: "terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "contact-us",
    element: <ContactUs />,
  },
  // { path: "my-profile", element: <PrivateRoute component={MyProfile} /> },
  { path: "/*", element: <NotFound /> },
];
